import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";
import { LocalStorageService } from "src/app/utils/localstorage.service";

@Injectable({ providedIn: "root" })
export class PermissionGuard {

  constructor(private localStorage: LocalStorageService) { }

  /**
   * Checks if user has a certain role in localStorage.
   */
  canActivate(route: ActivatedRouteSnapshot) {
    return (route.data.permissionsRequired.every(
                (p: string) => this.localStorage.get("userPermissions")?.permissions?.includes(p))
              || route.data.roleOverride === this.localStorage.get("userPermissions")?.role);
  }
}
